import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import head from 'lodash/head';
import getPath from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import { Select } from '../../../../styles/styled';
import Mapper from './Mapper';

class MailchimpWizard extends Component {
  constructor(props) {
    super(props);

    const { integration } = props;
    console.log('integration', integration);
    const list = this.getList();

    // `mergeFields` is coming from old version (source:target)
    // `mapping` is the new version (target: source)
    const mergeFields = getPath(integration, 'value.mergeFields', {}); // old version
    const mappings = getPath(integration, 'value.mappings', {}); // new version
    const oldListId = getPath(integration, 'value.mailChimpId', ''); // old version
    const newListId = getPath(integration, 'value.listId', ''); // version
    const listId = oldListId || newListId;
    const listItem = this.getListItem(listId);

    this.state = {
      listItem: !isEmpty(listItem) ? listItem : head(list),
      mappings: !isEmpty(mappings) ? mappings : mergeFields, // new version
      completed: false,
      saving: false,
      error: '',
    };
  }

  componentDidMount() {
    this.updateIntegration({ initial: true });
  }

  updateIntegration = (metadata = {}) => {
    const { completed, saving, error } = this.state;
    this.props.onUpdate({
      completed,
      saving,
      error: '',
      ...metadata,
    });
  };

  saving = (value = true) => {
    return new Promise(resolve => {
      this.setState({ saving: value }, () => {
        this.updateIntegration();
        resolve();
      });
    });
  };

  async save() {
    const {
      listItem: { id: listId },
      mappings,
    } = this.state;
    const { soundcastId, onSave } = this.props;
    try {
      await this.saving();
      await Axios.patch('/api/integration/mailchimp/subscribers', {
        listId,
        soundcastId,
        mappings,
      });
      await this.saving(false);
      onSave();
    } catch (err) {
      await this.saving(false);
      const serverMsg = getPath(err, 'response.data.message', false);
      const error = !serverMsg
        ? `There was an error updating the list. In case it persist please contact support.`
        : serverMsg;
      this.updateIntegration({ error });
    }
  }

  onChangeList = e => {
    const listId = e.target.value || '';
    const listItem = this.getListItem(listId);
    if (!isEmpty(listItem)) {
      this.setState({
        listItem,
      });
    }
  };

  getList() {
    const { integration } = this.props;
    return getPath(integration, 'config.list', []);
  }

  handleMapperStateChange = mapperState => {
    const { completed, mappings } = this.state;
    const { matches, isCompleted } = mapperState;
    if (completed !== isCompleted || !isEqual(matches, mappings)) {
      console.log('mapper state', mapperState);
      this.setState(
        {
          mappings: matches,
          completed: isCompleted,
          error: '',
        },
        this.updateIntegration
      );
    }
  };

  getListItem(listId) {
    const listItem = this.getList().find(item => isEqual(item.id, listId));
    return !isEmpty(listItem) ? listItem : {};
  }

  renderGroupsMapper() {
    const { saving, mappings, listItem } = this.state;
    const listItemFields = getPath(listItem, 'merge_fields', []);
    const prefix = str => `Mailchimp ${str}`;
    const mappingText = {
      FNAME: 'First Name',
      LNAME: 'Last Name',
      ADDRESS: 'Address',
      BIRTHDAY: 'Birthday',
      PHONE: 'Phone',
    };

    // show every field tags
    const targetFields = listItemFields
      .map(({ tags: key }) => {
        return {
          key,
          text: key in mappingText ? prefix(mappingText[key]) : prefix(key),
          required: false,
        };
      });

    // listeners
    const sourceFields = [
      {
        key: 'firstName',
        text: 'Listener First Name',
      },
      {
        key: 'lastName',
        text: 'Listener Last Name',
      },
    ];

    // conversion old props to new props
    const oldversionMappings = {
      firstNameTag: 'firstName',
      lastNameTag: 'lastName',
    };

    // make sure to identify old version and new for mappings
    // old version: {firstNameTag: 'FNAME', lastNameTag: 'LNAME'}
    // new version: {FNAME: 'firstName', LNAME: 'lastName'}
    // // this code is the same on the server
    const nmappings = Object.keys(mappings).reduce((prev, key) => {
      let mailchimpTag = key;
      let listenerProp = mappings[key];
      if (key in oldversionMappings) {
        mailchimpTag = mappings[key];
        listenerProp = oldversionMappings[key];

        // remove no export
        if (isEqual(mailchimpTag, 'No Export')) {
          return prev;
        }
      }

      prev[mailchimpTag] = listenerProp;
      return prev;
    }, {});

    return (
      <Mapper
        targetFields={targetFields}
        sourceFields={sourceFields}
        oldMatches={nmappings}
        onMapperStateChange={this.handleMapperStateChange}
        disabled={saving}
      />
    );
  }

  render() {
    const { listItem } = this.state;
    const list = this.getList();
    const listItemId = getPath(listItem, 'id', '');

    return (
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <div className="text-large font-weight-600">Choose List</div>
          <div className="text-medium">Select the list you want to add information to</div>
          <div className="padding-one-top">
            <Select className="text-large" value={listItemId} onChange={this.onChangeList}>
              {isEmpty(list) && <option>Loading...</option>}
              {list.map(({ id, name }, i) => {
                return (
                  <option value={id} key={`${id}-${i}`}>
                    {name}
                  </option>
                );
              })}
            </Select>
          </div>
        </div>
        <div className="col-lg-12 col-md-12">
          <div className="text-large font-weight-600">Match Your Fields</div>
          <div className="padding-one-top">{this.renderGroupsMapper()}</div>
        </div>
      </div>
    );
  }
}

MailchimpWizard.propTypes = {
  soundcastId: PropTypes.string,
  integration: PropTypes.object,
  onSave: PropTypes.func,
};

MailchimpWizard.defaultProps = {
  soundcastId: '',
  integration: {},
  onSave: () => {},
};

export default MailchimpWizard;
